module.exports = __webpack_public_path__ + "img/reward-money-light.c438460f.png";